<div [style.width.px]="resourcesColumnWidthPx">
  <nz-select
    class="mt-2 ms-2 me-3 select-width"
    nzAllowClear
    nzShowSearch
    nzMode="tags"
    [nzMaxTagCount]="1"
    [nzPlaceHolder]="'general.filter' | translate"
    [ngModel]="selectedUnassignedFilter"
    (ngModelChange)="setUnassignedShiftsFilter($event)"
  >
    @for (option of unassignedShifts; track option) {
      <nz-option
        [nzLabel]="
          option.name +
          ' - ' +
          (option.startDatetime | date: DateTimeFormat.DayAndMonth)
        "
        [nzValue]="option.id"
      ></nz-option>
    }
  </nz-select>
</div>
